import templateUrl from './edit-onboarding-policy-document-modal.html'

export const EditOnboardingPolicyDocumentModalComponent = {
    controller: EditOnboardingPolicyDocumentModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
}

function EditOnboardingPolicyDocumentModalController(onboardingPolicyService, utilityService) {
    'ngInject'
    const vm = this;
    vm.$onInit = onInit;
    vm.filterResult = filterResult;
    vm.onMoveItem = onMoveItem;
    vm.onSave = onSave;

    function onInit() {
        vm.document = vm.resolve.document;
        vm.documentGroups = vm.resolve.documentGroups;
        vm.index = vm.resolve.index;
        vm.onboardingPolicy = vm.resolve.onboardingPolicy;
        vm.isNew = vm.resolve.isNew;
        vm.sortIndexMode = 'bottom';

        if (vm.isNew) {
            // Generate a new array consisting of the old array concatenated with the new value.
            // Then insert the item into its resolved sort index.
            vm.results = vm.onboardingPolicy.OnboardingDocuments.concat([vm.document]);
            utilityService.moveItem(vm.results, vm.document, vm.document.SortIndex);
        } else {
            vm.results = vm.onboardingPolicy.OnboardingDocuments.map(function (document, i) {
                return i === vm.index ? vm.document : document;
            });
        }

        vm.allowedFileTypeOptions = createMultiInputOptions(function () {
            return vm.document.AllowedFileTypes;
        });
    }

    function onMoveItem(items, selectedItem, index) {
        utilityService.moveItem(items, selectedItem, index);
        selectedItem.SortIndex = index;
    }

    function onSave() {
        validateChange();
        if (vm.editForm && vm.editForm.$invalid) {
            alert("Cannot save: validation errors in form");
        }

        if (vm.isNew && !confirm("The document will be added to this list. This cannot be undone. Continue?")) {
            return;
        }

        const request = {
            Name: vm.document.Name,
            SortIndex: vm.sortIndexMode === 'specific' ? vm.document.SortIndex : null,
            Description: vm.document.Description,
            DocumentGroupID: vm.document.DocumentGroup ? vm.document.DocumentGroup.OnboardingPolicyDocumentGroupID
                : null,
            IsRequired: vm.document.IsRequired,
            UseImageCropper: vm.document.UseImageCropper,
            AllowedFileTypes: vm.document.AllowedFileTypes,
            BlankFormUpload: vm.document.BlankFormUpload
        };

        const saved = vm.isNew ? onboardingPolicyService.addDocument(vm.onboardingPolicy.OnboardingPolicyID, request)
            : onboardingPolicyService.updateDocument(vm.onboardingPolicy.OnboardingPolicyID,
                vm.document.OnboardingPolicyDocumentID, request);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));

        return saved.then(function (id) {
            if (vm.isNew) {
                request.OnboardingPolicyDocumentID = id;
            }
            vm.close({ $value: request });
        })
    }

    function validateChange() {
        if (!vm.editForm) {
            return;
        }
    }

    function filterResult(result) {
        return result !== vm.document || vm.sortIndexMode === 'specific';
    }

    /**
     * Create kendo-multi-select options for the data source returned from the sourceFn
     * @param {any} sourceFn A function that returns an array representing data selected
     * in the multi-select.
     */
    function createMultiInputOptions(sourceFn) {
        // Return options that perform "server filtering" by enabling the filter
        // and auto-adding the filter text to the list of potential results.
        return {
            filters: "contains",
            dataTextField: "value",
            dataValueField: "value",
            valuePrimitive: true,
            autoClose: false,
            dataSource: {
                transport: {
                    read: function (options) {
                        const results = sourceFn().map(function (item) {
                            return {
                                value: item
                            };
                        });
                        if (options.data && options.data.filter && options.data.filter.filters
                            && options.data.filter.filters[0]) {
                            // Add filter text to the results.
                            results.unshift({
                                value: options.data.filter.filters[0].value
                            });
                        }
                        options.success(results);
                    }
                },
                serverFiltering: true,
                serverPaging: true,
                pageSize: 30
            }
        };
    }
}
